import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { formatNumber } from '@app/helpers/webform';
import { WebformService, KeyValue, CalcType } from '@app/services/webform.service';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'webform-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit, OnDestroy {
  @Input() element: any;
  @ViewChild('summary') summary!: ElementRef<any>;

  formData: KeyValue = {};
  formId!: string;
  plugin: CalcType = null;

  formatNumber: Function = formatNumber;
  #formDataSub!: Subscription;

  readonly #webform = inject(WebformService);
  readonly #cdr = inject(ChangeDetectorRef);

  async ngOnInit(): Promise<void> {
    this.#formDataSub = this.#webform.formData.subscribe(async (v: KeyValue) => {
      if (!v || !Object.keys(v).length) return;
      this.plugin = this.element['#plugin'];
      this.formData = v;
      this.#cdr.detectChanges();
    });

    this.formId = this.element['#webform'];
  }

  ngOnDestroy(): void {
    if (this.#formDataSub) this.#formDataSub.unsubscribe();
  }

  get isDealer(): boolean {
    return this.formId.includes('haendler') || this.formId.includes('dealer');
  }
}
